import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LoginPage from './auth/LoginPage';
import AdminGate from './auth/AdminGate';
import Header from './components/Header';
import FulfillmentBanner from './components/FulfillmentBanner';
import OrdersPage from './components/pages/OrdersPage';
import CustomersPage from './components/pages/CustomersPage';
import TransactionsPage from './components/pages/TransactionsPage';
import ItemsPage from './components/pages/ItemsPage';
import ItemsSearchPage from './components/pages/ItemsSearchPage';
import IncomeReportPage from './components/pages/IncomeReportPage';
import InventoryReportPage from './components/pages/InventoryReportPage';
import CategorySalesReportPage from './components/pages/CategorySalesReportPage';
import SkuSalesReportPage from './components/pages/SkuSalesReportPage';
import DailySalesReportPage from './components/pages/DailySalesReportPage';
import ItemsWithoutCategoryReport from './components/pages/ItemsWithoutCategoryReport';
import SobeysPricesReportPage from './components/pages/SobeysPricesReportPage';
import NewsPage from './components/pages/NewsPage';
import ReportsPage from './components/pages/ReportsPage';

const loadingSx = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f7f7f7',
} as const;

const AppShell = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={loadingSx}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <AdminGate>
      <Router>
        <Box
          sx={{
            minHeight: '100vh',
            backgroundColor: '#f7f7f7',
            fontFamily: '"Quicksand", "Roboto", sans-serif',
          }}
        >
          <Header />
          <FulfillmentBanner />
          <Box
            component="main"
            sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 }, py: 4 }}
          >
            <Switch>
              <Route path="/orders"><OrdersPage /></Route>
              <Route path="/transactions"><TransactionsPage /></Route>
              {/* /items/search must precede /items/:tenant so the
                  Switch doesn't capture "search" as a tenant slug. */}
              <Route path="/items/search"><ItemsSearchPage /></Route>
              <Route path="/items/:tenant/category/:categoryId"><ItemsPage /></Route>
              <Route path="/items/:tenant"><ItemsPage /></Route>
              <Route path="/items"><ItemsPage /></Route>
              <Route path="/customers"><CustomersPage /></Route>
              <Route path="/news"><NewsPage /></Route>
              <Route path="/reports/inventory/:year"><InventoryReportPage /></Route>
              <Route path="/reports/inventory"><InventoryReportPage /></Route>
              <Route path="/reports/income"><IncomeReportPage /></Route>
              <Route path="/reports/daily-sales"><DailySalesReportPage /></Route>
              <Route path="/reports/category-sales"><CategorySalesReportPage /></Route>
              <Route path="/reports/sku-sales"><SkuSalesReportPage /></Route>
              <Route path="/reports/sobeys-prices"><SobeysPricesReportPage /></Route>
              <Route path="/reports/items-without-category">
                <ItemsWithoutCategoryReport />
              </Route>
              <Route path="/reports"><ReportsPage /></Route>
              <Redirect exact from="/" to="/transactions" />
            </Switch>
          </Box>
        </Box>
      </Router>
    </AdminGate>
  );
};

const App = () => (
  <AuthProvider>
    <AppShell />
  </AuthProvider>
);

export default App;
